import { LucideCopy } from "lucide-react";
import { useToast } from "./useToast";

export default function useCopy() {
  const { toast } = useToast();
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    toast({
        description: (
          <div className="flex items-center gap-2">
            <LucideCopy className="inline-block h-4 -mt-[1.5px] stroke-indigo-600" />
            Copied to clipboard
          </div>
        ),
      });
  };
  return { copyToClipboard };
}

